import { Address, isDefined } from '@aloft/toolkit-shared';

export function extractSubjectAddress(doc: Document): Address | undefined {
  const subjectPropertyTag = doc.getElementsByTagName('PROPERTY')[0];
  const AddressLineText = subjectPropertyTag?.getAttribute('_StreetAddress') ?? undefined;
  const CityName = subjectPropertyTag?.getAttribute('_City') ?? undefined;
  const StateCode = subjectPropertyTag?.getAttribute('_State') ?? undefined;
  const PostalCode = subjectPropertyTag?.getAttribute('_PostalCode') ?? undefined;
  if ([AddressLineText, CityName, StateCode, PostalCode].some(isDefined)) {
    return {
      AddressLineText,
      CityName,
      StateCode,
      PostalCode,
    };
  }
  return undefined;
}
